import react, { useEffect } from "react";
import Box from "@mui/joy/Box";
import "../../css/registro.css";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Button from "@mui/joy/Button";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import FormHelperText from "@mui/joy/FormHelperText";
import Input from "@mui/joy/Input";
import Textarea from "@mui/joy/Textarea";
import Autocomplete from "@mui/joy/Autocomplete";
import { getCities, getCountries } from "countries-cities";
import axios from "axios";
import Typography from "@mui/joy/Typography";
import AspectRatio from "@mui/joy/AspectRatio";
import imageCompression from "browser-image-compression";
import heic2any from "heic2any";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Checkbox from "@mui/joy/Checkbox";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/joy/Alert";
import ErrorIcon from "@mui/icons-material/Error";
import HikingIcon from "@mui/icons-material/Hiking";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import { getCountryCallingCode } from "libphonenumber-js";
import { getCode } from "country-list";

function Primero({ setFormdata, formdata, descripcion }) {
  return (
    <Box>
      <Box sx={{ display: "grid", gap: 2 }}>
        <FormControl>
          <FormLabel>RUT o DNI</FormLabel>
          <Input
            placeholder="11.111.111-1"
            required
            onChange={(value) => {
              setFormdata(value, "rut");
            }}
            value={formdata.rut}
          />
          <FormHelperText>
            Usado solo para verificación y seguridad de la comunidad.
          </FormHelperText>
        </FormControl>
      </Box>
      <Box sx={{ maxWidth: 425, marginTop: 1 }}>
        <Box>
          <FormControl>
            <FormLabel>Sobre mí</FormLabel>
            <Textarea
              minRows={4}
              required
              onChange={(value) => {
                descripcion(value, "descripcion_perfil");
              }}
              value={formdata.descripcion_empresa}
            />
            <FormHelperText>
              Cuenta brevemente tu experiencia, actividades y qué te diferencia
              como guía.
            </FormHelperText>
          </FormControl>
        </Box>
      </Box>
    </Box>
  );
}
function Segundo({ formdata, especialidades, escribirActividades }) {
  return (
    <Box>
      <Box sx={{ display: "grid", gap: 2 }}>
        <FormControl>
          <FormLabel>Tus especialidades</FormLabel>
          <Autocomplete
            disableClearable
            multiple
            options={especialidades}
            required
            onChange={(event, value) => {
              escribirActividades(value.slice(0, 3));
            }}
            value={formdata.especialidades}
          />
          <FormHelperText>
            Escoge hasta 3 especialidades que representen mejor tu experiencia
            como guía de turismo aventura.
          </FormHelperText>
        </FormControl>
      </Box>
    </Box>
  );
}

function Tercero({ subirFoto, vistaPrevia, navigate }) {
  return (
    <Box>
      <Box sx={{ marginBottom: 2 }}>
        <AspectRatio>
          {vistaPrevia ? (
            <img
              src={vistaPrevia}
              alt="Vista previa"
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "5px",
              }}
            />
          ) : null}
        </AspectRatio>
      </Box>

      <Box>
        <input
          type="file"
          accept="image/*"
          id="subir-foto"
          style={{ display: "none" }}
          onChange={subirFoto}
        />
        <label htmlFor="subir-foto">
          <Button
            component="span"
            variant="outlined"
            color="neutral"
            startDecorator={<CloudUploadIcon />}
            sx={{ marginBottom: "1rem", width: "100%" }}
          >
            Subir Foto de Perfil
          </Button>
        </label>
      </Box>
      <Checkbox
        color="success"
        variant="soft"
        label="Al registrar tu empresa confirmas que has leído y aceptas nuestros Términos y Condiciones."
        size="sm"
        checked={true}
        onClick={() => {
          window.open("/terminos-condiciones", "_blank");
        }}
      />
    </Box>
  );
}
export default function RegistroGuiasDeTurismo() {
  let [formdata, setFormdata] = react.useState({
    rut: "",
    descripcion_perfil: "",
    foto_de_perfil: "",
    especialidades: [],
  });
  let [paises, setPaises] = react.useState(getCountries());
  let [ciudades, setCiudades] = react.useState();
  let [orden, setOrden] = react.useState(0);
  let [activar, setActivar] = react.useState(true);
  let [textoBoton, setTextoBoton] = react.useState("Siguiente");
  let [desactivarBoton, setDesactivarBoton] = react.useState(false);
  let [vistaPrevia, setVistaPrevia] = react.useState(false);
  let [estadoalerta, setestadoAlerta] = react.useState(false);
  let [contenidoAlerta, setcontenidoAlerta] = react.useState({
    titulo: "",
    contenido: "",
    icono: "",
    color: "",
    decorator: "",
  });
  let navigate = useNavigate();
  let [especialidades, setEspecialidades] = react.useState();

  useEffect(() => {
    /* codigo hecho por chatgpt, verifica que exista cada parte del formdata*/
    let verificarFormulario = Object.values(formdata).every(
      (v) => v && v.toString().trim() !== ""
    );
    if (verificarFormulario && orden === 1) {
      setDesactivarBoton(false);
    } else if (orden === 1) {
      setDesactivarBoton(true);
    }
  }, [formdata]);
  useEffect(() => {
    function formatearRut(value) {
      if (!value) return "";

      // Limpia todo excepto números y K
      let rut = value.replace(/[^0-9kK]/g, "").toUpperCase();

      if (rut.length < 2) return rut;

      const dv = rut.slice(-1);
      let cuerpo = rut.slice(0, -1);

      cuerpo = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      return `${cuerpo}-${dv}`;
    }
    let rutconFormato = formatearRut(formdata.rut.slice(0, 12));
    if (rutconFormato !== formdata.rut) {
      setFormdata((value) => ({
        ...value,
        rut: rutconFormato,
      }));
    }
  }, [formdata.rut]);

  /* Recoger intereses personales */

  useEffect(() => {
    try {
      /* OBTENER BEARER TOKEN */
      let token = localStorage.getItem("token");

      /* OBTENER BEARER TOKEN */

      let getactividades = async () => {
        let actividadesrecoger = await axios.get(
          `${process.env.REACT_APP_FRONTEND_URL}/api/categorias`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        let actividadesnombres = actividadesrecoger.data.map(
          (x) => x.nombre_categoria
        );
        setEspecialidades(actividadesnombres);
      };
      getactividades();
    } catch (err) {
      console.log("Error en recoger actividades");
    }
  }, []);

  /* Recoger intereses personales */

  function escribirFormulario(x, y) {
    let valor = x;
    let objeto = y;
    setFormdata((x) => ({
      ...x,
      [objeto]: valor.target.value,
    }));
    console.log(formdata);
    if (y === "pais") {
      setCiudades(getCities(x.target.value));
      setActivar(false);
    }
  }
  function escribirActividades(x) {
    setFormdata((valoranterior) => ({ ...valoranterior, especialidades: x }));
  }
  function descripcionEmpresa(x, y) {
    let valor = x;
    let objeto = y;
    setFormdata((x) => ({
      ...x,
      [objeto]: valor.target.value.slice(0, 200),
    }));
    console.log(formdata);
  }
  useEffect(() => {
    let verificarRegistro = async () => {
      let token = localStorage.getItem("token");

      let getRegistro = await axios.get(
        `${process.env.REACT_APP_FRONTEND_URL}/api/comprobar-registro-guia-turismo`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      let verificarCuentaEmpresa = await axios.get(
        `${process.env.REACT_APP_FRONTEND_URL}/api/comprobar-registro-empresa`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (getRegistro.data) {
        navigate("/panel/escritorio");
      }
      if (verificarCuentaEmpresa.data) {
        navigate("/panel/escritorio");
      }
    };
    verificarRegistro();
  }, []);

  async function enviarFormularioGuiaTuristico() {
    try {
      let token = localStorage.getItem("token");

      let formularioEmpresa = new FormData();

      formularioEmpresa.append("rut", formdata.rut);
      formularioEmpresa.append(
        "descripcion_perfil",
        formdata.descripcion_perfil
      );

      formularioEmpresa.append(
        "foto_de_perfil",
        formdata.foto_de_perfil,
        formdata.foto_de_perfil.name
      );
      formularioEmpresa.append(
        "especialidades",
        JSON.stringify(formdata.especialidades)
      );

      let enviarFormularioEmpresa = await axios.post(
        `${process.env.REACT_APP_FRONTEND_URL}/api/registro/cuenta-guia-turismo`,
        formularioEmpresa,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (enviarFormularioEmpresa.status === 200) {
      }
      setestadoAlerta(true);
      setcontenidoAlerta(() => ({
        contenido: `Solicitud recibida exitosamente`,
        color: "success",
        decorator: <HikingIcon />,
      }));
      setTimeout(() => {
        setestadoAlerta(false);
        navigate("/panel/escritorio");
      }, 3000);
    } catch (err) {
      console.log("Tenemos el siguiente error al enviar la solicitud: " + err);
      setcontenidoAlerta(() => ({
        contenido: `Faltan campos por rellenar`,
        color: "danger",
        decorator: <ErrorIcon />,
      }));
      setestadoAlerta(true);
      setTimeout(() => {
        setestadoAlerta(false);
      }, 3000);
    }
  }

  function Boton() {
    if (orden === 0) {
      return (
        <Box sx={{ display: "flex", width: "100%" }}>
          <Button
            variant="outlined"
            color="neutral"
            onClick={() => {
              if (orden === 0) {
                /*
                setTextoBoton("Enviar Solicitud");
                setOrden(orden + 1);
                setDesactivarBoton(true);
                */
                setOrden(orden + 1);
              }
            }}
            sx={{ marginTop: 2, width: "inherit" }}
          >
            {textoBoton}
          </Button>
        </Box>
      );
    } else if (orden > 0 && orden <= 1) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 2,
          }}
        >
          <Button
            variant="plain"
            color="neutral"
            onClick={() => {
              setOrden(orden - 1);
            }}
          >
            Retroceder
          </Button>
          <Button
            variant="outlined"
            color="neutral"
            onClick={() => {
              setOrden(orden + 1);
            }}
          >
            Siguiente
          </Button>
        </Box>
      );
    } else if (orden === 2) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 2,
          }}
        >
          <Button
            variant="plain"
            color="neutral"
            onClick={() => {
              setOrden(orden - 1);
            }}
          >
            Retroceder
          </Button>
          <Button
            variant="outlined"
            color="neutral"
            onClick={() => {
              console.log(formdata);
              enviarFormularioGuiaTuristico();
            }}
          >
            Registrarme como Guía
          </Button>
        </Box>
      );
    }
  }

  function Orden() {
    return (
      <Box>
        {orden === 0 ? (
          <Primero
            setFormdata={escribirFormulario}
            descripcion={descripcionEmpresa}
            formdata={formdata}
          />
        ) : null}
        {orden === 1 ? (
          <Segundo
            formdata={formdata}
            especialidades={especialidades}
            escribirActividades={escribirActividades}
          />
        ) : null}

        {orden === 2 ? (
          <Tercero
            subirFoto={manejarSubirFoto}
            vistaPrevia={vistaPrevia}
            navigate={navigate}
          />
        ) : null}
      </Box>
    );
  }

  /* SUBIR FOTO LO HIZO CHATGPT  JUNTO CON COMPRESION DE IMAGEN Y CONVERSIÓN DE ARCHIVO*/

  const manejarSubirFoto = async (event) => {
    const archivo = event.target.files[0];
    if (archivo) {
      let opciones = {
        maxSizeMB: 1, // Máximo 1MB
        maxWidthOrHeight: 1024, // Redimensionar si es necesario
        useWebWorker: true,
      };
      try {
        let imagenRecibida = archivo;
        /* EN CASO DE ARCHIVOS .HEIC */

        if (
          imagenRecibida.type === "image/heic" ||
          imagenRecibida.type === "image/heif"
        ) {
          let blob = await heic2any({
            blob: archivo,
            toType: "image/jpeg",
            quality: 0.8,
          });
          imagenRecibida = new File([blob], "imagen_convertida.jpg", {
            type: "image/jpeg",
          });
        }

        /* EN CASO DE ARCHIVOS .HEIC */

        let imagenComprimida = await imageCompression(imagenRecibida, opciones);

        // Convertir a JPG si el formato es diferente
        const imagenBlob = await imageCompression(imagenComprimida, {
          fileType: "image/jpeg",
        });

        // Crear un nuevo archivo JPG
        const imagenJPG = new File([imagenBlob], "imagen.jpg", {
          type: "image/jpeg",
        });

        setFormdata((valoranterior) => ({
          ...valoranterior,
          foto_de_perfil: imagenJPG,
        }));
        setVistaPrevia(URL.createObjectURL(imagenJPG));
      } catch (err) {
        console.log("Tenemos un error para procesar la fotografía " + err);
      }
    }
  };

  useEffect(() => {
    return () => {
      if (vistaPrevia) {
        URL.revokeObjectURL(vistaPrevia);
      }
    };
  }, [vistaPrevia]);
  /* SUBIR FOTO LO HIZO CHATGPT  JUNTO CON COMPRESION DE IMAGEN Y CONVERSIÓN DE ARCHIVO*/

  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        width: "100vw",
        height: "100vh",
      }}
    >
      {estadoalerta && (
        <Alert
          variant="soft"
          className="notificacion"
          color={contenidoAlerta.color}
          startDecorator={contenidoAlerta.decorator}
        >
          {contenidoAlerta.contenido}
        </Alert>
      )}
      <Box
        sx={{
          height: "100vh",
          width: "40vw",
          position: "relative",
          zIndex: 2,
          alignContent: "center",

          backgroundColor: "#fbfcfe",
        }}
      >
        <Box sx={{ padding: 10 }}>
          <Box sx={{ marginBottom: 2, display: "grid", gap: 1 }}>
            <Box sx={{ display: "grid", justifyContent: "center" }}>
              <AspectRatio
                variant="plain"
                ratio="1"
                sx={{
                  width: "100px",
                  marginBottom: "2rem",
                  borderRadius: "12px",
                }}
              >
                <img
                  src={`${process.env.REACT_APP_FRONTEND_URL}/uploads/logo.svg`}
                  alt="logo"
                  style={{ objectFit: "contain" }}
                />
              </AspectRatio>
            </Box>

            <Typography level="h4">
              Registrate como Guía de Turismo Aventura
            </Typography>
            <Typography level="body-sm">
              Ofrece aventuras, tours y experiencias guiadas a una comunidad que
              busca vivir más al aire libre.
            </Typography>
          </Box>
          {Orden()}
          {Boton()}
        </Box>
      </Box>
      <Box
        sx={{ height: "100vh", width: "60vw" }}
        className="fondoRegistroGuiasTurismo"
      ></Box>
    </Box>
  );
}
